import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

export const BlurCover = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('absolute inset-0 z-[1] bg-page/75 backdrop-blur-xs', className)} {...props} />
}
